import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2bbe507e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2bbe507e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe507e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bbe507e')) {
      api.createRecord('2bbe507e', component.options)
    } else {
      api.reload('2bbe507e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2bbe507e&scoped=true&", function () {
      api.rerender('2bbe507e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/sheet-to-review/components/Category/index.vue"
export default component.exports